import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { EAuthType } from '@onesource/schemas';
import { z } from 'zod';
import { Header } from '#/components/header';
import { Footer } from '#/components/footer';
import { generateOttMutationFn, isLoggedIn } from '@onesource/services';

const SignInPage = lazyRouteComponent(() => import('src/pages/sign-in'));

export const Route = createFileRoute('/auth/login')({
  validateSearch: z.object({
    auth_type: z.nativeEnum(EAuthType).optional().catch(undefined),
    return_url: z.string().optional().catch(undefined),
    return_app: z.string().optional().catch(undefined),
    app_name: z.string().optional().catch(undefined),
    tab: z.enum(['magiclink', 'email']).optional().catch(undefined),
  }),
  beforeLoad: async ({ search }) => {
    const { return_url: returnUrl, return_app: returnApp, app_name: appName } = search;
    if (!isLoggedIn() || !returnUrl || !returnApp) {
      return;
    }

    try {
      const decodedReturnUrl = decodeURIComponent(returnUrl);
      const data = await generateOttMutationFn({
        targetApp: returnApp,
        redirectUrl: decodedReturnUrl,
      });

      const finalUrl = appName ? `${data.redirectUrl}&appName=${appName}` : data.redirectUrl;
      window.location.href = finalUrl;
    } catch (error) {
      console.error('[SSO Redirect] Failed to generate OTT:', error);
    }
  },
  component: () => (
    <>
      <Header />
      <SignInPage />
      <Footer />
    </>
  ),
});
